import { type Mark } from '../../Form/RangeSlider/types.ts';

export const swapValuesWithLabels = (values: number[], mappings: Mark[]) =>
  values.map(val => mappings.find(mapping => mapping.value === val)?.label);
